import React from 'react'

export const FormLabel: React.FC<{label: string}> = ({label}) => {
  return (
    <p className="text-[14px] leading-[18px] font-medium text-primary mb-[10px]">
      {label}
    </p>
  )
}
